import * as ambassadorWixPortfolioCollectionsV1Collection from './portfolio-collections-v1-collection-collections.http.js';
import * as ambassadorWixPortfolioCollectionsV1CollectionTypes from './portfolio-collections-v1-collection-collections.types.js';
import * as ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes from './portfolio-collections-v1-collection-collections.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCollection(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.CreateCollectionRequest,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.CreateCollectionRequest,
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.CreateCollectionResponse,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.CreateCollectionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioCollectionsV1Collection.createCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/portfolio/collections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCollection(): __PublicMethodMetaInfo<
  'GET',
  { collectionId: string },
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.GetCollectionRequest,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.GetCollectionRequest,
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.GetCollectionResponse,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.GetCollectionResponse
> {
  const payload = { collectionId: ':collectionId' } as any;

  const getRequestOptions =
    ambassadorWixPortfolioCollectionsV1Collection.getCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/portfolio/collections/{collectionId}',
    pathParams: { collectionId: 'collectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listCollections(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.ListCollectionsRequest,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.ListCollectionsRequest,
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.ListCollectionsResponse,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.ListCollectionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioCollectionsV1Collection.listCollections(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/api/v1/portfolio/collections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCollection(): __PublicMethodMetaInfo<
  'PATCH',
  { collectionId: string },
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.UpdateCollectionRequest,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.UpdateCollectionRequest,
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.UpdateCollectionResponse,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.UpdateCollectionResponse
> {
  const payload = { collection: { id: ':collectionId' } } as any;

  const getRequestOptions =
    ambassadorWixPortfolioCollectionsV1Collection.updateCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/api/v1/portfolio/collections/{collection.id}',
    pathParams: { collectionId: 'collectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCollection(): __PublicMethodMetaInfo<
  'DELETE',
  { collectionId: string },
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.DeleteCollectionRequest,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.DeleteCollectionRequest,
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.DeleteCollectionResponse,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.DeleteCollectionResponse
> {
  const payload = { collectionId: ':collectionId' } as any;

  const getRequestOptions =
    ambassadorWixPortfolioCollectionsV1Collection.deleteCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/api/v1/portfolio/collections/{collectionId}',
    pathParams: { collectionId: 'collectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCollections(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.QueryCollectionsRequest,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.QueryCollectionsRequest,
  ambassadorWixPortfolioCollectionsV1CollectionUniversalTypes.QueryCollectionsResponse,
  ambassadorWixPortfolioCollectionsV1CollectionTypes.QueryCollectionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPortfolioCollectionsV1Collection.queryCollections(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/api/v1/portfolio/collections/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Collection as CollectionOriginal,
  Image as ImageOriginal,
  ImageType as ImageTypeOriginal,
  ImageTypeWithLiterals as ImageTypeWithLiteralsOriginal,
  CommonImage as CommonImageOriginal,
  Point as PointOriginal,
  UnsharpMasking as UnsharpMaskingOriginal,
  PageUrlV2 as PageUrlV2Original,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  AdminRemoveMenuItemsResponse as AdminRemoveMenuItemsResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateCollectionRequest as CreateCollectionRequestOriginal,
  CreateCollectionResponse as CreateCollectionResponseOriginal,
  GetCollectionRequest as GetCollectionRequestOriginal,
  GetCollectionResponse as GetCollectionResponseOriginal,
  ListCollectionsRequest as ListCollectionsRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListCollectionsResponse as ListCollectionsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  UpdateCollectionRequest as UpdateCollectionRequestOriginal,
  UpdateCollectionResponse as UpdateCollectionResponseOriginal,
  DeleteCollectionRequest as DeleteCollectionRequestOriginal,
  DeleteCollectionResponse as DeleteCollectionResponseOriginal,
  QueryCollectionsRequest as QueryCollectionsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  QueryCollectionsResponse as QueryCollectionsResponseOriginal,
} from './portfolio-collections-v1-collection-collections.types.js';
